<template>
  <div class="title">
    <h2>예약 내역이 없습니다.</h2>
    <p>지금 바로 간편하게 셔틀버스를 예약해보세요!</p>
    <button type="button" class="active btnB" @click="goBook">
      예약하러 가기
    </button>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "NoneTicket",
  setup() {
    const store = useStore();
    const router = useRouter();
    const bookSteps = computed(() => store.state.book.bookSteps);
    const goBook = async () => {
      await store.dispatch("member/CLEAR_ACCESS_TOKEN");
      await store.dispatch("member/CLEAR_USER_INFO");
      const { page } = bookSteps.value[0];
      router.push({ name: page });
    };
    return { goBook };
  },
};
</script>

<style></style>
